import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { deleteSupportAttachment, getSupportDetailById, updateAttchmentSupportRequest, updateSupportRequest } from "../../api/Applications";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import "../orgnization/Organization.css";
import { Button, Form, Input, Modal, ModalBody, ModalHeader } from "reactstrap";
import CreateRequest from "./CreateRequest";
import CreatePlatformRequest from "./CreatePlatformSupportRequest";
import Loader from "../../components/Loader/Loader";
import { handleFileUpload } from "../../utils/ImageToBase64";
import { failed, success } from "../../utils/Tostify";
import { useConfirmDialog } from "../../hooks/useConfirmDialog";
const SupportDetailsPage = () => {
  const [requestDetails, setRequestDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();
  const supportdata = location?.state?.supportData;
  const supportIdFromState = location.state?.id;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let token = useSelector((state) => state.userReducer.token);
  const [showEditModal, setShowEditModal] = useState(false);
  const [userRole, setUserRole] = useState("");
  const { getConfirmation } = useConfirmDialog();
  const [forceCreateRequest, setForceCreateRequest] = useState(false);
  const [editedComment, setEditedComment] = useState("");
  const [editedInternalComment, setEditedInternalComment] = useState("");
  const [showSaveIcon, setShowSaveIcon] = useState(false);
  const [isEditingExternal, setIsEditingExternal] = useState(false);
  const [isEditingInternal, setIsEditingInternal] = useState(false);

  useEffect(() => {
    const role = localStorage.getItem("userRole");
    setUserRole(role);
  }, []);

  const getSupportDetails = async () => {
  try {
    const idToUse = supportdata?.['_id'] || supportIdFromState;

    if (!idToUse) {
      return;
    }

    setIsLoading(true);
    const response = await getSupportDetailById({ dispatch, token, supportId: idToUse });

    if (response?.status === "SUCCESS") {
      setRequestDetails(response.data);
    }
  } catch (error) {
    // Optionally handle error in UI
  }
   finally {
    setIsLoading(false);
  }
};

useEffect(() => {
  if (supportdata || supportIdFromState) {
    getSupportDetails();
  }
}, [supportdata, supportIdFromState]);

  useEffect(()=>{
    getSupportDetails();
  },[supportdata, supportIdFromState]);

  const triggerFileInputDoc = (index) => {
    document.getElementById(`fileInputDoc-${index}`).click(); // Trigger file input
  };

  const handleFileSelect = async (event, formId, docId) => {
    const file = event.target.files[0];
    if (file) {
      setIsLoading(true);
      let base64pdfForm = await handleFileUpload(file);
      const payload = {
        attachments: [
          {
            _id: docId, // Existing attachment ID
            base64String: base64pdfForm,
            name: file.name
          }
        ]
      };

      try {
        const res = await updateAttchmentSupportRequest({
          values: payload,
          dispatch,
          token,
          supportId: requestDetails._id
        });

        if (res.status === "SUCCESS") {
          success(res?.message);
          await getSupportDetails();
          setIsLoading(false);
        } else {
          failed(res?.message || "Something went wrong");
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
    }
  };

  const handleDownloadDocument = async (url) => {
    window.open(url);
  };

  const handleDeleteAttchment = async (docId) => {
    let res;
    try {
      const confirmed = await getConfirmation({
        title: "Attention!",
        entryName: "",
        actionBtnTitle: "Yes",
        message: "Are you sure you want to delete the attchment?"
      });
      if (confirmed) {
        setIsLoading(true);
        res = await deleteSupportAttachment({ dispatch, token, supportId: requestDetails?._id, docId });
        if (res?.status === "SUCCESS") {
          await getSupportDetails();
          setIsLoading(false);
          success(res?.message);
        } else {
          setIsLoading(false);
          failed(res?.message);
        }
      }
    } catch (error) {
      setIsLoading(false);
      failed(error?.message || "An error occurred");
    }
  };

  useEffect(() => {
    setEditedComment(requestDetails?.externalComment?.commentText || "");
    setShowSaveIcon(false);
  }, [requestDetails]);


  useEffect(() => {
    setEditedInternalComment(requestDetails?.internalComment?.commentText || "");
    setShowSaveIcon(false);
  }, [requestDetails]);

  const handleEditClick = (type) => {
    if (type === "external") {
      setIsEditingExternal(true);
    } else {
      setIsEditingInternal(true);
    }
  };

  const handleDiscardChanges = (type) => {
    if (type === "external") {
      setEditedComment(requestDetails?.externalComment?.commentText || "");
      setIsEditingExternal(false);
    } else {
      setEditedInternalComment(requestDetails?.internalComment?.commentText || "");
      setIsEditingInternal(false);
    }
    setShowSaveIcon(false);
  };

  const handleSaveComment = async () => {
    let res;
    try {
      const requestPayload = {
        ...requestDetails,
        externalComment: {
          userId: requestDetails.createdBy._id,
          commentText: editedComment
        },
        internalComment: {
          userId: requestDetails.createdBy._id,
          commentText: editedInternalComment
        }
      };

      res = await updateSupportRequest({ values: requestPayload, dispatch, token, supportId: requestDetails._id });

      if (res?.status === "SUCCESS") {
        success(res?.message);
        setShowSaveIcon(false);
        setIsEditingExternal(false);
        setIsEditingInternal(false);
      }
    } catch (error) {
      failed(res?.message);
    }
  };

  return (
    <>
      <div className="organization_view_details support-detail paginator_blk table_listing_color">
        {isLoading ? <Loader /> : null}
        <div className='profile_block'>
          <div className='profile_main d-flex justify-content-between align-items-center flex-wrap'>
            <div className='profile_info flex-wrap'>
              <div className="d-flex gap-3 align-items-center">
                <h6>Title :</h6>
                <p>{requestDetails?.title}</p>
              </div>
            </div>
            {userRole === "Platform" && <button
              className="edit_profile"
              onClick={() => setShowEditModal(true)}
            >
              Edit Details
            </button>}
          </div>

          <div className='row data_profile m-0'>
            <div className="col-md-4 col-sm-6 mb-3">
              <h4>Request Type</h4>
              <p>{requestDetails?.requestType}</p>
            </div>
            <div className="col-md-4 col-sm-6 mb-3">
              <h4>Created By</h4>
              <p>{`${requestDetails?.createdBy?.firstName || "N/A"} ${requestDetails?.createdBy?.lastName || ""}`}</p>
            </div>
            <div className="col-md-4 mb-4">
              <h4>Status</h4>
              <p>{requestDetails?.status}</p>
            </div>
            <div className="col-md-4 col-sm-6 mb-3">
              {userRole === "Platform" && (
                <div>
                  <h4>Category</h4>
                  <p>{requestDetails?.category}</p>
                </div>
              )}
            </div>
            <div className="col-md-4 col-sm-6 mb-3">
              {userRole === "Platform" && (
                <div>
                  <h4>Priority</h4>
                  <p>{requestDetails?.priority}</p>
                </div>
              )}
            </div>
            <div className="col-md-4 col-sm-6 mb-3">
              {userRole === "Platform" && (
                <div>
                  <h4>Assigned To</h4>
                  <p>{`${requestDetails?.assignedTo?.firstName || "N/A"} ${requestDetails?.assignedTo?.lastName || ""}`}</p>
                </div>
              )}
            </div>
            <div className="col-md-4 col-sm-6 mb-3">
              {userRole === "Platform" && (
                <div>
                  <h4>Organization</h4>
                  <p>{requestDetails?.organizationId?.name}</p>
                </div>
              )}
            </div>
            <div className="col-md-4 col-sm-6 mb-3">
              {userRole === "Platform" && (
                <div>
                  <h4>Resolution</h4>
                  <p>{requestDetails?.resolution}</p>
                </div>
              )}
            </div>
            <div className="col-md-4 col-sm-6 mb-3">
              <h4>Update Date</h4>
              <p>{moment(requestDetails?.updatedAt).format("MMM-DD-YYYY")}</p>
            </div>
          </div>

          {requestDetails?.description &&
            <div className='profile_main d-flex justify-content-between align-items-center flex-wrap mt-4'>
               <div className="d-flex gap-3 align-items-center">
                <h6>Description :</h6>
                <p>{requestDetails?.description}</p>
              </div>
            </div>}

          <div className="profile_main row  mt-4 mx-0">
            <div className="col-xl-2 mb-3">
            <h6>Comment :</h6>
            </div>
            <div className="col-xl-5 mb-3">
            <div className="d-flex align-items-center gap-3">
              <div className="note_block w-100">
                <Form className="text_block">
                  {userRole === "Platform" && <label>External comment</label>}
                  {!isEditingExternal ? (
                    <p className="text_area_blk" style={{ whiteSpace: "pre-line" }}>{editedComment || "No comments"}</p>
                  ) : (
                    <Input
                      className="text_area_blk"
                      type="textarea"
                      value={editedComment}
                      onChange={(e) => {
                        if (e.target.value.length <= 255) {
                          setEditedComment(e.target.value);
                          setShowSaveIcon(true);
                        }
                      }}
                      disabled={requestDetails?.status === "Completed"}
                      maxLength={255}
                      autoFocus
                    />
                  )}
                </Form>
              </div>
              <div className="d-flex flex-column gap-2">
                {showSaveIcon && (
                  <>
                    <i className="fa fa-save" onClick={handleSaveComment} style={{ cursor: "pointer" }}></i>
                    <i className="fa fa-times" onClick={() => handleDiscardChanges("external")} style={{ cursor: "pointer", color: "red" }}></i>
                  </>
                )}
                {!showSaveIcon && (
                  <i className="fa fa-edit" onClick={() => handleEditClick("external")} style={{ cursor: "pointer" }}></i>
                )}
              </div>
            </div>
            </div>
            <div className="col-xl-5 mb-3">
            {userRole === "Platform" && (
              <div className="d-flex align-items-center gap-3">
                <div className="note_block w-100">
                  <Form className="text_block">
                    <label>Internal comment</label>
                    {!isEditingInternal ? (
                      <p className="text_area_blk" style={{ whiteSpace: "pre-line" }}>{editedInternalComment || "No comments"}</p>
                    ) : (
                      <Input
                        className="text_area_blk"
                        type="textarea"
                        value={editedInternalComment}
                        onChange={(e) => {
                          if (e.target.value.length <= 255) {
                            setEditedInternalComment(e.target.value);
                            setShowSaveIcon(true);
                          }
                        }}
                        disabled={requestDetails?.status === "Completed"}
                        maxLength={255}
                        autoFocus
                      />
                    )}
                  </Form>
                </div>
                <div className="d-flex flex-column gap-2">
                  {showSaveIcon && (
                    <>
                      <i className="fa fa-save" onClick={handleSaveComment} style={{ cursor: "pointer" }}></i>
                      <i className="fa fa-times" onClick={() => handleDiscardChanges("internal")} style={{ cursor: "pointer", color: "red" }}></i>
                    </>
                  )}
                  {!showSaveIcon && (
                    <i className="fa fa-edit" onClick={() => handleEditClick("internal")} style={{ cursor: "pointer" }}></i>
                  )}
                </div>
              </div>
            )}
            </div>
          </div>

          <>
            <div className="">
            <div className="text-end">
                  <Button type="button" disabled={requestDetails?.status === "Completed"} className="save_btn" onClick={() => { setShowEditModal(true); setForceCreateRequest(true); }}>
                    Add Attachments
                  </Button>
                  </div>
              <div className="table-responsive">
                <table>
                  {/* <th></th> */}
                  {requestDetails?.attachments?.length > 0 && <th>Attachments</th>}
                  {requestDetails?.attachments?.length > 0 && requestDetails?.attachments.map((doc, index) => (
                    <tbody key={doc?._id}>
                      <tr className={index % 2 === 0 ? 'first_block' : 'second_block'}>
                        <td>{index + 1}</td>
                        <td>
                          {doc?.fileName}
                        </td>
                        <td className="p-0">
                          <span className="material-symbols-outlined" style={{ cursor: "pointer" }} onClick={() => doc?.filePath?.signedUrl ? handleDownloadDocument(doc?.filePath?.signedUrl) : null} >download</span>
                        </td>
                        {userRole === "Platform" &&
                          <td className="p-0 upload_blk">
                            <span
                              className="material-symbols-outlined"
                              style={{ cursor: 'pointer' }}
                              onClick={() => triggerFileInputDoc(index)} // Trigger file input when upload icon is clicked
                            >
                              upload
                            </span>
                            <input
                              type="file"
                              id={`fileInputDoc-${index}`}
                              style={{ display: 'none' }} // Hide the file input
                              onChange={(e) => handleFileSelect(e, "", doc._id, "doc")} // Handle file selection
                            />
                          </td>
                        }
                        {userRole === "Platform" &&
                          <td>
                            <i
                              className="fas fa-trash-alt"
                              style={{ cursor: "pointer" }}
                              onClick={() => handleDeleteAttchment(doc._id)}
                            />
                          </td>}
                      </tr>
                      <tr>
                        <td colSpan={8} className="bg_light"></td>
                      </tr>
                    </tbody>))}
                </table>
              </div>
            </div>
          </>
          <div className="d-flex gap-3 justify-content-center mt-3">
            <button className="back_blockk" type="button" onClick={() => navigate(-1)}>Back</button>
          </div>
        </div>
      </div>

      <Modal isOpen={showEditModal} toggle={() => setShowEditModal(false)} size="xl">
        <ModalHeader toggle={() => setShowEditModal(false)} className="assign_blk p-0 mb-3"></ModalHeader>
        <ModalBody>
          {forceCreateRequest || userRole !== "Platform" ? (
            <CreateRequest
              onCancel={() => {
                setShowEditModal(false);
                setForceCreateRequest(false); // Reset state
              }}
              editData={requestDetails}
              isEditMode={true}
            />
          ) : (
            <CreatePlatformRequest
              onCancel={() => setShowEditModal(false)}
              editData={requestDetails}
              isEditMode={true}
            />
          )}
        </ModalBody>
      </Modal>
    </>
  );
};

export default SupportDetailsPage;
